<template>
  <!-- 检测领域 -->
  <div class="detection" ref="detection" style="width: 100%">
    <!-- 页面头部 -->
    <pageHeader ref="pageHeader" pageStatus="2" />
    <section class="detection-page-ctn">
      <!-- 产品介绍 -->
      <section class="product-box">
        <div class="product-name">{{detailInfo.name}}</div>
        <div class="product-attr">
            <span class="span-1" v-if="detailInfo.testPeriod">{{detailInfo.testPeriod}}</span>
            <span class="span-2" v-if="detailInfo.urgent == 1">可加急</span>
            <span class="span-3" v-if="detailInfo.sample">样品：{{detailInfo.sample}}</span>
        </div>
        <div class="product-desc" :class="{'m-h': detailInfo.productOutline.length > 79 && !viewMoreDesc}" v-if="detailInfo.productOutline" ref="infoDesc">
          {{detailInfo.productOutline.length > 76 && !viewMoreDesc ? detailInfo.productOutline.slice(0,70) : detailInfo.productOutline}}
          <span class="open-desc" v-if="!viewMoreDesc && detailInfo.productOutline.length > 76" @click="viewMoreDesc = true">展开</span>
        </div>
        <div class="product-concat">
          <div class="concat-online" @click="openOnlineConsulting">在线咨询<i class="el-icon-arrow-right"></i></div>
          <div class="concat-self" @click="selfCount">自助询价<i class="el-icon-arrow-right"></i></div>
        </div>
      </section>
      <!-- 服务详情 -->
      <section class="service-detail">
        <div class="cm-title">服务内容</div>
        <div class="service-html" v-html="detailInfo.detail"></div>
      </section>
      <!-- 交付流程 -->
      <section class="deliver-step">
        <div class="cm-title">交付流程</div>
        <div class="deliver-box">
          <div class="deliver-row" v-for="(pitem, pidx) in deliverInfo" :key="pidx">
            <div class="deliver-item" v-for="(citem, cidx) in pitem" :key="cidx">
              <div class="deliver-one">
                <div class="deliver-img">
                  <img v-if="pidx === 0 && cidx === 0" src="@/assets/detection/mb-process-1.png" alt="">
                  <img v-if="pidx === 0 && cidx === 1" src="@/assets/detection/mb-process-2.png" alt="">
                  <img v-if="pidx === 0 && cidx === 2" src="@/assets/detection/mb-process-3.png" alt="">
                  <img v-if="pidx === 1 && cidx === 0" src="@/assets/detection/mb-process-4.png" alt="">
                  <img v-if="pidx === 1 && cidx === 1" src="@/assets/detection/mb-process-5.png" alt="">
                  <img v-if="pidx === 1 && cidx === 2" src="@/assets/detection/mb-process-6.png" alt="">
                </div>
                <div class="deliver-text">
                  <div class="deliver-text-inn">{{citem}}</div>
                </div>
              </div>
              <div class="deliver-line" v-if="cidx != 2">
                <img src="@/assets/detection/step-arrow.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 增值服务 -->
      <section class="add-service">
        <div class="cm-title">增值服务</div>
        <div class="add-service-box">
          <div class="add-service-row" v-for="(pitem, pidx) in serviceList" :key="pidx">
            <div class="add-service-item" v-for="(item, idx) in pitem" :key="idx">
              <div class="service-item-img">
                <img v-if="pidx ===0 && idx === 0" src="@/assets/detection/mb-service-1.png" alt="">
                <img v-if="pidx ===0 && idx === 1" src="@/assets/detection/mb-service-2.png" alt="">
                <img v-if="pidx ===0 && idx === 2" src="@/assets/detection/mb-service-3.png" alt="">
                <img v-if="pidx ===0 && idx === 3" src="@/assets/detection/mb-service-4.png" alt="">
                <img v-if="pidx ===1 && idx === 0" src="@/assets/detection/mb-service-5.png" alt="">
                <img v-if="pidx ===1 && idx === 1" src="@/assets/detection/mb-service-6.png" alt="">
                <img v-if="pidx ===1 && idx === 2" src="@/assets/detection/mb-service-7.png" alt="">
                <img v-if="pidx ===1 && idx === 3" src="@/assets/detection/mb-service-8.png" alt="">
              </div>
              <div class="service-item-info">
                <div class="service-item-name">
                  <div v-if="Array.isArray(item)">
                    <div v-for="citem in item" :key="citem">{{citem}}</div>
                  </div>
                  <div v-else>{{item}}</div>
                </div>
                <!-- <div class="service-item-name">{{item}}</div> -->
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 国联优势 -->
      <section class="advantage">
        <div class="cm-title">国联优势</div>
        <div class="adv-box">
          <div class="adv-item" v-for="(item, idx) in advantageList" :key="idx">
            <div class="adv-item-img">
                <img v-if="idx === 0" src="@/assets/detection/mb-advantage-1.png" alt="">
                <img v-if="idx === 1" src="@/assets/detection/mb-advantage-2.png" alt="">
                <img v-if="idx === 2" src="@/assets/detection/mb-advantage-3.png" alt="">
                <img v-if="idx === 3" src="@/assets/detection/mb-advantage-4.png" alt="">
                <img v-if="idx === 4" src="@/assets/detection/mb-advantage-5.png" alt="">
            </div>
            <div class="adv-item-ctn">
              <div class="adv-item-name adv-item-test">{{item.name}}</div>
              <div class="adv-item-desc adv-item-test">{{item.desc}}</div>
            </div>
          </div>
        </div>
      </section>
    </section>   
    <!-- 相关推荐 -->
    <section class="abort-product">
      <div class="cm-title">相关推荐</div>
      <div class="ab-product-box">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(pitem, idx) in recommendList" :key="idx">
            <div class="ab-pdt-row" v-for="(mitem, idx) in pitem" :key="idx">
              <div class="ab-pdt-item" @click="toProductDetail(item)" v-for="item in mitem" :key="item.id">
                <div class="ab-pdt-img">
                  <img :src="$path + item.image" alt="">
                </div>
                <div class="ab-pdt-name">{{item.name}}</div>
                <div class="ab-pdt-desc">样品：{{item.sample}}</div>
                <div class="ab-pdt-mark">
                  <span v-if="item.testPeriod">{{item.testPeriod}}</span>
                  <span v-if="item.urgent == 1">可加急</span>
                </div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev-inn" slot="button-prev">
            <van-icon name="arrow-left" />
          </div>
          <div class="swiper-button-next-inn" slot="button-next">
            <van-icon name="arrow" />
          </div>
        </swiper>
      </div>
    </section>
    <!-- 咨询表单 -->
    <section>
      <consultForm  ref="consultForm" />
    </section>
  </div>
</template>

<script>


// 设置rem
document.documentElement.style.fontSize =
document.documentElement.clientWidth / 7.5 + 'px';

  import {onlineConsulting,
    onlineConsultingHalf,
    onlineMobileConsultingHalf} from '@/unit/common';
import 'swiper/dist/css/swiper.css';
import 'swiper/dist/js/swiper.js';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
export default {
  components: {
    pageHeader: () => import("@/components/header"),
    consultForm: () => import("@/components/consult"),
    Swiper, SwiperSlide
  },
  metaInfo() {
    return {
      title: this.pageInfo.metaTitle, // set a title
      meta: [
        {
          // set meta
          name: "keyWords",
          content: this.pageInfo.metaKeywords,
        },
        {
          name: "description",
          content: this.pageInfo.metaDescription,
        },
      ],
    };
  },
  watch:{
    $route(){
      this.id = this.$route.query.id
      this.getProductdetail();
      this.getProductList();

    }
  },
  data() {
    return {
      id: '',
      type: '',
      detailInfo: {},
      recommendList: [],
      pageInfo: {
        metaTitle: "",
        metaKeywords: "",
        metaDescription: "",
      },
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }],
      // 服务流程
      deliverInfo: [['咨询沟通' , '签约付款', '送样采样'], ['检验检测', '出具报告', '增值服务']],
      // 增值服务
      serviceList: [
        ['检验检测', '监督抽查', ['环境评价', '环境治理']], 
        ['安全评价', '技术服务', '咨询认证']
      ],
      // 国联优势
      advantageList: [
        {
          name: '覆盖广泛',
          desc: '42个业务领域、121个大类、600个产品、6000+参数指标'
        },
        {
          name: '设备精良',
          desc: '30000平方米自有智能化实验室、2800台高端仪器、近200家签约实验室'
        },
        {
          name: '专业团队',
          desc: '700+精英专家团队、10万+累计服务客户'
        },
        {
          name: '荣誉资质',
          desc: '获得CMA、CNAS、CATL、GLP、GCP等150多项资质荣誉'
        },
        {
          name: '体验至上',
          desc: '码上明白追溯产品来源电子报告系统+订单查询系统实时掌握服务进度'
        }
      ],
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next-inn',
          prevEl: '.swiper-button-prev-inn'
        }
      },
      viewMoreDesc: false // 查看一级菜单描述
    };
  },
  created() {
    this.id = this.$route.query.id
    this.getProductdetail();
    this.getProductList();
  },
  mounted() {
    const obj = {
      platformType : 1,
      targetPage : window.location.href
    }
    this.$api.iotHome.loggingData(obj)
    .then((res) => {
      if (res.data.success == true) {
       console.log('数据记录成功');
    }
    })
  },
  methods: {
    //   产品详情
    getProductdetail() {
      this.$api.iotHome.detail({}, this.id).then((res) => {
        if (res.data.success == true) {
          console.log('res',res)
          this.detailInfo = res.data.data;
          this.detailInfo.detail = this.detailInfo.detail.replace(
            /src="(?![http])/g,
            'src="' + this.$path
          );
          this.detailInfo.detail = this.detailInfo.detail.replace(/4008082011/g,'4008001252')
          this.detailInfo.productOutline = this.detailInfo.productOutline.replace(/4008082011/g,'4008001252')
          this.pageInfo = {
            metaTitle: res.data.data.metaTitle,
            metaKeywords: res.data.data.metaKeywords,
            metaDescription: res.data.data.metaDescription,
          };
          window.localStorage.setItem("sourceNameForm",this.detailInfo.name);
        }
      });
    },
    // 相关推荐
    getProductList() {
      const aboutrecommendList = {
        id: this.id,
        siteId: 0
      };
      this.$api.iotHome.aboutrecommendList(aboutrecommendList).then((res) => {
        if (res.data.success == true) {
          // res.data.data = [...res.data.data, ...res.data.data, ...res.data.data]
           let arr = [];
          (res.data.data || []).slice(0, 12).forEach((item, idx) => {
            if(idx % 4 === 0) {
              arr[arr.length] = []
            } 
            if(idx % 2 === 0) {
              arr[arr.length-1][arr[arr.length-1].length] = []
            } 
            arr[arr.length-1][arr[arr.length-1].length-1].push(item)
          })
          
          this.recommendList = arr;
        }
      });
    },
    // 咨询表单
    selfCount() {
      const consultForm = this.$refs.consultForm
      consultForm.$data.dialogVisible = true
    },
    // 跳转详情
    toProductDetail(data) {
      const { href } = this.$router.resolve({
          path: "/detectionDetail",
          query: {
            id: data.id
          }
      })
      window.open(href, '_blank')
    },
    // 在线咨询
    openOnlineConsulting(){
      const specs="height=600,width=1000,alwaysRaised,directories=no,toolbar=no,titlebar=no,menubar=no,scrollbars=no,left=300,top = 200, resizable=no,location=no, status=no"
      window.open("https://ada.baidu.com/site/wjzzrg3w/agent?imid=d55b08de4f857a0038a33d33ef9afaf7","_blank",specs)
      // onlineConsultingHalf()
    },
    toindex(data){
      this.$router.push({
        path: "/",
        query: {
          type: data ? data : ''
        }
      });
    },
    show53() {
      const specs="height=600,width=1000,alwaysRaised,directories=no,toolbar=no,titlebar=no,menubar=no,scrollbars=no,left=300,top = 200, resizable=no,location=no, status=no"
      window.open("https://ada.baidu.com/site/wjzzrg3w/agent?imid=d55b08de4f857a0038a33d33ef9afaf7","_blank",specs)
    },
  },
};
</script>
<style lang="scss" scoped>
// 产品介绍
.product-box {
  width: 100%;
  padding: .7rem .3rem;
  background: #ECEFF6;
  .product-name {
    width: 100%;
    line-height: .58rem;
    font-size: .5rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #282B45;
  }
  .product-attr {
    margin-top: .2rem;
    white-space: nowrap;
    display: flex;
    span {
      height: .4rem;
      line-height: .41rem;
      background: #ECEFF6;
      border: 1px solid #777995;
      border-radius: 3px;
      padding: 0 .13rem;
      font-size: .24rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #777995;
      margin-right: .12rem;
      display: inline-block;
      text-overflow:ellipsis;
      white-space: nowrap;
      overflow: hidden;
      &.span-1 {
        max-width: 2rem;
      }
      &.span-3 {
        margin-right: 0;
        max-width: 3.65rem;
      }
    }
  }
  .product-desc {
    margin-top: .42rem;
    // max-height: 1.26rem;
    font-size: .26rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #777995;
    line-height: .42rem;
    position: relative;
    &.m-h {    
      overflow: hidden;
      max-height: 1.26rem;
    }
  }
  .open-desc {
    position: absolute;
    // bottom: 0;
    // right: 0;
    font-size: .26rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #224CFF;
    line-height: .46rem;
    background: #ECEFF6;
    padding: 0 .15rem;
    margin-top: -1px;
  }
  .product-concat {
    display: flex;
    justify-content: flex-start;
    margin-top: .5rem;
  }
  .concat-online {
    height: .6rem;
    line-height: .62rem;
    background: #395FFF;
    width: 2.11rem;
    font-size: .28rem;
    text-align: center;
    color: #fff;
    margin-right: .2rem;
    &:active {
      opacity: .7;
    }
  }
  .concat-self {
    height: .6rem;
    line-height: .62rem;
    width: 2.11rem;
    border: 1px solid #7892FF;
    font-size: .28rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #395FFF;
    text-align: center;
    &:active {
      opacity: .7;
    }
  }
}

// 服务内容
.service-detail {
  width: 100%;
  padding: .7rem .3rem;
  .service-html {
    margin-top: .38rem;
  }
}
.cm-title {
  font-size: .38rem;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #282B45;
  line-height: .37rem;
}
.deliver-step {
  height: 4.31rem;
  width: 100%;
  padding: .7rem .3rem 0;
  background: #ECEFF6;
  position: relative;
}
.add-service {
  width: 100%;
  height: 8.61rem;
  background: url('../../assets/detection/mb-detection-bg.png') no-repeat center center;
  background-size: cover;
  padding-top: 2.7rem;
}
.deliver-box {
  position: absolute;
  top: 1.47rem;
  left: .28rem;
  width: 6.93rem;
  height: 4.74rem;
  background: #fff;
  border-radius: .2rem;
  padding: .53rem .56rem 0;
  .deliver-row {
    display: flex;
    justify-content: flex-start;
    &:last-child {
      margin-top: .41rem;
    }
  }
  .deliver-item {
    display: flex;
    justify-self: flex-start;
  }
  .deliver-img {
    width: 1.1rem;
    height: 1.1rem;
    border-radius: 100%;
    border: 1px solid #E1E2F5;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    img {
      width:45%;
    }
  }
  .deliver-text {
    font-size: .28rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #282B45;
    line-height: .33rem;
    height: .33rem;
    position: relative;
    margin-top: .2rem;
    // width: 1.2rem;

  }
  .deliver-text-inn {
    width: 1.3rem;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
  }
  .deliver-line {
    height: .22rem;
    width: 1.24rem;
    position: relative;
    top: .45rem;
    left: 0rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

// 优势
.add-service {
  padding: 2.47rem .3rem .7rem;
  .cm-title {
    color: #fff;
  }
  .add-service-box {
    margin-top: .4rem;
  }
  .add-service-row {
    display: flex;
    justify-content: flex-start;
    &:first-child {
      margin-bottom: .14rem;
    }
  }
  .add-service-item {
    width: 2.2rem;
    height: 2.15rem;
    border: 1px solid #434656;
    padding-top: .51rem;
    margin-right: .1rem;
    &:last-child {
      margin-right: 0;
    }
  }
  .service-item-img {
    width: .5rem;
    margin: 0 auto;
    height: .5rem;
    img {
      object-fit: contain;
      width: 100%;
    }
  }
  .service-item-info {
    padding-top: .2rem;
    height: .84rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .service-item-name {
    font-size: .3rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #FFFFFF;
    line-height: .33rem;
    text-align: center;
    padding: 0 .2rem;
    div {
      white-space: nowrap;
    }
  }
}

// 优势
.advantage {
  padding: .7rem .3rem;
  .adv-box {
    margin-top: .4rem;
  }
  .adv-item {
    height: 1.84rem;
    padding: 0 .5rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid #E1E2F5;
    margin-bottom: .2rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .adv-item-img {
    width: 1.45rem;
    margin-right: .3rem;
    img {
      width: 100%;
      object-fit: contain;
    }
  }
  .adv-item-ctn {
    flex: 1;
    width: 4.17rem;
    word-wrap: normal;
    word-break: break-all;
  }
  .adv-item-name {
    font-size: .32rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #34364E;
    line-height: .31rem;
  }
  .adv-item-desc {
    margin-top: .16rem;
    font-size: .24rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #A2A3B4;
    line-height: .3rem;
  }
}

// 相关推荐
.abort-product {
  background: #ECEFF6;
  padding: .73rem .3rem .56rem;
  .ab-product-box {
    margin-top: .43rem;
  }
  .ab-pdt-row {
    display: flex;
    justify-content: flex-start;
    margin-bottom: .22rem;
    &:last-child {
      margin-bottom: 0;
    }
    * {
      text-align: left;
    }
  }
  .ab-pdt-item {
    width: 3.38rem;
    height: 3.9rem;
    border-radius: .14rem;
    overflow: hidden;
    background-color: #fff;
    margin-right: .13rem;
    // &:last-child {
    //   margin-right: 0;
    // }
    &:active {
      background: #395FFF;
      * {
        color: #fff;
      }
      
      span {
        background: #4064FF;
      }
    }
  }
  .ab-pdt-img {
    width: 100%;
    height: 2.02rem;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
  .ab-pdt-name {
    padding: 0 .18rem;
    // height: .3rem;
    font-size: .3rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #282B45;
    line-height: .4rem;
    margin-top: .20rem;
    text-overflow:ellipsis;    
    white-space: nowrap;
    overflow: hidden;
  }
  .ab-pdt-desc {
    height: .26rem;
    font-size: .24rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #A2A3B4;
    line-height: .26rem;
    text-overflow:ellipsis;    
    white-space: nowrap;
    overflow: hidden;
    padding: 0 .18rem;
    margin-top: .12rem;
  }
  .ab-pdt-mark {
    margin-top: .23rem;
    padding: 0 .18rem;
    white-space: nowrap;

    span {
      padding: 0 .1rem;
      line-height: .42rem;
      background: #F5F5F5;
      border-radius: 3px;
      font-size: .24rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #777995;
      margin-right: .12rem;
      text-overflow:ellipsis;    
      white-space: nowrap;
      overflow: hidden;
      display: inline-block;
      &:first-child {
        max-width: 1.9rem;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.swiper-button-prev-inn, .swiper-button-next-inn {
  width: .6rem;
  height: .6rem;
  display: inline-block;
  border: 1px solid #777995;
  border-radius: 1px;
  color: #777995;
  text-align: center;
  line-height: .6rem;
  margin-top: .4rem;
  outline-style:none;
  &:active {
    outline-style:none;
  }
}
.swiper-button-disabled {
  border: 1px solid #A2A3B4;
  color: #A2A3B4;

}
.swiper-container {
  text-align: center;
}
.swiper-button-prev-inn {
  margin-right: .21rem;
}
</style>


<style lang="scss">
  
  .service-html {

    table {
      width: 100%!important;
    }
    img {
      width: 100%!important;
    }
  }
</style>